import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d310898"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "material-table" }
const _hoisted_2 = { class: "material-table__actions" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 添加新材料 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("加入待选 >>")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_LibraryForm = _resolveComponent("LibraryForm")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_table_wrapper = _resolveComponent("table-wrapper")!
  const _directive_perm = _resolveDirective("perm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_space, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_input_search, {
            value: _ctx.keyword,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
            "enter-button": "",
            class: "w300",
            placeholder: "请输入材料名称关键字",
            onSearch: _ctx.search
          }, null, 8, ["value", "onSearch"]),
          _withDirectives((_openBlock(), _createBlock(_component_LibraryForm, {
            isEdit: false,
            onRefresh: _ctx.search
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onRefresh"])), [
            [_directive_perm, '/material/library/create']
          ]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.add
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_table_wrapper, {
      loading: _ctx.loading,
      dataSource: _ctx.data,
      pagination: _ctx.pagination,
      onOnSelectionChange: _ctx.onSelectionChange,
      onOnTableChange: _ctx.onTableChange,
      columns: _ctx.columns,
      tableHeight: _ctx.tableHeight,
      showFullJump: false
    }, {
      bizNo: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(record.bizNo), 1)
      ]),
      _: 1
    }, 8, ["loading", "dataSource", "pagination", "onOnSelectionChange", "onOnTableChange", "columns", "tableHeight"])
  ]))
}